// src/routes/AuthRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const AuthRoute = ({ children }) => {
  const token = localStorage.getItem("token");

  // S'il est déjà connecté, redirige vers /verify-tf
  return token ? <Navigate to="/verify-tf" /> : children;
};

export default AuthRoute;

